import { render } from "./AdyenPaymentModalElement.vue?vue&type=template&id=4530a790"
const script = {}

import "./AdyenPaymentModalElement.vue?vue&type=style&index=0&id=4530a790&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__